import CaptainDocumentAPI from 'dashboard/api/captain/document';
import { createStore } from './storeFactory';

export default createStore({
  name: 'CaptainDocument',
  API: CaptainDocumentAPI,
  actions: mutationTypes => ({
    async rescrape({ commit }, documentId) {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainDocumentAPI.rescrape(documentId);
        commit(mutationTypes.EDIT, { id: documentId, status: response.data.status });
        return response.data;
      } catch (error) {
        console.error('Error in rescrape action:', error);
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
